import { changedetails } from './ActionTypes';

const changeDetails = (details) => {
    return (dispatch)=>{
        dispatch({type: changedetails, details:details})
    }
}

export default changeDetails;